import { create } from "zustand";

interface ExtensionPopoverState {
  openedPopovers: Record<string, boolean>;
  setPopoverState: (name: string, isOpen: boolean) => void;
}

export const useExtensionPopoverStore = create<ExtensionPopoverState>(
  (set) => ({
    openedPopovers: {},
    setPopoverState: (name, isOpen) =>
      set((state) => ({
        openedPopovers: {
          ...state.openedPopovers,
          [name]: isOpen,
        },
      })),
  })
);
